// package.json
var version = "0.44.7";

// src/version.ts
var compatibilityVersion = 10;
export {
  compatibilityVersion,
  version as npmVersion
};
